import React, { useState, useEffect, useRef } from "react";
import Footer2 from "components/Footers/Footer2";
import AdminNavbar from "components/Navbars/AdminNavbar";
import brand from "assets/img/new/way/brand.png";
import visions from "assets/img/new/way/visions.png";
import map from "assets/img/new/way/map.png";
import bgg from "assets/img/bgg.png";
import girl from "assets/img/new/way/girl.png";
import infrastructure from "assets/img/new/way/infrastructure.png";
import curriculums from "assets/img/new/way/curriculums.png";
import furniture from "assets/img/new/way/furniture.png";
import sports from "assets/img/new/way/sports.png";
import yoga from "assets/img/new/way/yoga.png";
import teacher from "assets/img/new/way/teacher.png";
import bfly1 from "assets/img/bfly1.webp";
import clouds from "assets/img/clouds.webp";
import girlimg from "assets/img/girlimg.png";
import emailjs from "@emailjs/browser";
import franchisee from "assets/img/franchisee.png";
import axios from "axios";
import toast from "react-hot-toast";
import ReCAPTCHA from "react-google-recaptcha";

export default function Franchise() {
  const form = useRef(null);
  const [formStatus, setFormStatus] = useState("idle");
  const [captchaToken, setCaptchaToken] = useState(null);
  // const sendEmail = (e) => {
  //   e.preventDefault();

  //   emailjs
  //     .sendForm("service_wcgta79", "template_0aiumig", form.current, {
  //       publicKey: "fnc0ujCNZPYr2bPnl",
  //     })
  //     .then(
  //       () => {
  //         console.log("SUCCESS!");
  //         setFormStatus("success");
  //         // Reset the form
  //         if (form.current) {
  //           form.current.reset();
  //         }
  //         // Redirect to /thankyoupage
  //         window.location.href = "/partner-thank-you";
  //       },
  //       (error) => {
  //         console.log("FAILED...", error.text);
  //         setFormStatus("error");
  //         // Reset form status after a short delay
  //         setTimeout(() => {
  //           setFormStatus("idle");
  //         }, 1000);
  //       }
  //     );
  // };

  const sendEmail = async (event) => {
    event.preventDefault();

    const formData = new FormData(event.target);
    const data = {
      name: formData.get("name")?.trim(),
      email: formData.get("email")?.trim(),
      phone: formData.get("tel")?.trim(),
      city: formData.get("city")?.trim(),
      area: formData.get("area")?.trim(),
      investment: formData.get("investment"),
      start: formData.get("franchise"),
      captcha: captchaToken,
    };

    // Validation checks
    if (!data.name || data.name.length < 3) {
      toast.error("Name must be at least 3 characters long");
      return;
    }
    if (!data.phone) {
      toast.error("Phone number is required");
      return;
    }
    if (!/^\d{10}$/.test(data.phone)) {
      toast.error("Enter a valid 10-digit phone number");
      return;
    }
    if (!data.email) {
      toast.error("Email is required");
      return;
    }
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(data.email)) {
      toast.error("Enter a valid email address");
      return;
    }
    if (!data.city || data.city.length < 3) {
      toast.error("City must be at least 3 characters long");
      return;
    }
    if (!data.area || data.area.length < 3) {
      toast.error("Area Preferred must be at least 3 characters long");
      return;
    }
    if (!data.investment) {
      toast.error("Please select an Investment range");
      return;
    }
    if (!data.start) {
      toast.error("Please select when you are ready to start");
      return;
    }
    if (!captchaToken) {
      toast.error("Please verify you're not a robot");
      return;
    }

    try {
      const response = await axios.post("https://api.juniortoes.com/api/franchises", data);

      if (response.status === 200) {
        toast.success("Form submitted successfully!");
        window.location.href = "/partner-thank-you";
      }
    } catch (error) {
      console.error("Form submission error:", error);
      toast.error("Something went wrong. Please try again.");
    }
  };


  // const [activeIndex, setActiveIndex] = useState(null);

  // const toggleAccordion = (index) => {
  //   setActiveIndex(activeIndex === index ? null : index);
  // };

  return (
    <>
      <AdminNavbar fixed />

      <section
        className=" xl:pt-28 xl:pb-16 lg:pt-32 lg:pb-16 md:pt-24 pt-24 md:pb-16 pb-16 xl:block lg:block md:block sm:block block"
        style={{
          backgroundColor: "#f0f7fa",
          backgroundImage: `url(${bgg})`,
          backgroundPosition: "center center",
          backgroundRepeat: "repeat",
          backgroundSize: "55% auto",
        }}
      >
        <div className=" container mx-auto gap-6 xl:px-0 px-2">
          <div className=" flex justify-start top-0 absolute right-0 ">
            <img
              className="xl:w-44 lg:w-40 md:w-32 w-20 xl:pt-0 lg:pt-0 md:pt-8"
              src={clouds}
              alt=""
            />
          </div>

          <div className="container mx-auto xl:px-0 px-4">
            <div className="flex flex-wrap items-center">
              <div className="xl:w-6/12 lg:w-6/12 md:w-6/12">
                <h2 class="xl:text-5xl lg:text-4xl md:text-3xl text-2xl font-bold text-black xl:mt-8 mt-6">
                  Own a Preschool
                </h2>
                <p
                  class="xl:text-xl text-gray  xl:mt-2 mt-2"
                  style={{ lineHeight: 1.9 }}
                >
                  Become a part of the Junior Toes family and bring quality
                  early childhood education to your community. With our proven
                  curriculum, trusted brand, and comprehensive support, you can
                  build a successful franchise that shapes the future of young
                  learners. Fill out the form below to start your journey with
                  Junior Toes Pre-School.
                </p>
                {/* <h1 className="xl:text-4xl lg:text-3xl md:text-2xl pt-4 font-bold text-blue xl:pt-4">
                  Winner of 45+ Awards Across Categories
                </h1> */}
                <div className="xl:block lg:block md:block sm:hidden hidden ">
                  <div className=" ">
                    <img
                      className="xl:w-44 w-32 lg:-ml-8  "
                      src={bfly1}
                      alt=""
                    />
                  </div>
                </div>
              </div>
              <div className="xl:w-6/12 lg:w-6/12 md:w-6/12 xl:mt-0 lg:mt-0 md:mt-0 mt-12">
                <div className="flex">
                  <div className="xl:w-5/12 lg:w-8/12 xl:block lg:hidden hidden md:hidden sm:hidden">
                    <img
                      className="xl:w-12/12 lg:w-12/12"
                      src={girlimg}
                      alt=""
                    />
                  </div>

                  <div className=" bg-white border-blue rounded-xl shadow-xl  xl:p-8 lg:p-6 p-4 xl:-ml-4 z-10 ">
                    {/* {formStatus === "success" && (
                  <div className="text-center text-green-500 sofia-pro">
                    Thank you for submitting the form!
                  </div>
                )} */}

                    {/* Show Error Message */}
                    {formStatus === "error" && (
                      <div className="text-center text-red-500 sofia-pro">
                        There was an error submitting the form. Please try again.
                      </div>
                    )}
                    <h1 className="xl:text-3xl lg:text-3xl text-2xl text-black font-bold  text-center mb-8">
                      Franchise Enquire Now
                    </h1>

                    <form ref={form} onSubmit={sendEmail}>
                      <input
                        className="xl:w-12/12 w-12/12 rounded-lg borderform"
                        type="text"
                        id="text"
                        name="name"
                        placeholder="Name"
                        required
                      />

                      <input
                        className="xl:w-12/12 w-12/12 mt-4  rounded-lg borderform"
                        type="text"
                        id="text"
                        name="email"
                        placeholder="Email"
                        required
                      />

                      <input
                        className="xl:w-12/12 w-12/12 mt-4 rounded-lg borderform"
                        type="number"
                        id="number"
                        name="tel"
                        placeholder="Phone"
                        required
                      />

                      <div className="flex flex-wrap">
                        <div className="xl:w-6/12 lg:w-6/12 md:w-6/12 w-full">
                          <input
                            className="xl:w-12/12 w-12/12 mt-4  rounded-lg borderform"
                            type="text"
                            id="text"
                            name="city"
                            placeholder="City"
                            required
                          />
                        </div>

                        <div className="xl:w-6/12 lg:w-6/12 md:w-6/12 w-full px-1 ">
                          <input
                            className=" xl:w-12/12 w-12/12 mt-4  rounded-lg borderform"
                            type="text"
                            id="text"
                            name="area"
                            placeholder="Area Preferred"
                            required
                          />
                        </div>
                      </div>

                      <div className="">
                        <div className="">
                          <select
                            className="xl:w-12/12 w-12/12 mt-4  rounded-lg borderform"
                            id="academic"
                            name="investment"
                            placeholder=" Select Investment"
                            required
                          >
                            <option value="" disabled selected>
                              Select Investment
                            </option>

                            <option value="30-40 lakhs">30-40 lakhs</option>
                            <option value="40-50 lakhs">40-50 lakhs</option>
                            <option value="50-60 lakhs">50-60 lakhs</option>
                            <option value="Above 60lakhs">Above 60lakhs</option>
                          </select>
                        </div>

                        <div className="">
                          <select
                            className="xl:w-12/12 w-12/12 mt-4 mb-4 rounded-lg borderform "
                            id="academic"
                            name="franchise"
                            placeholder="How soon are you ready to start"
                            required
                          >
                            <option value="" disabled selected>
                              How soon are you ready to start
                            </option>

                            <option value="Immediately">Immediately</option>
                            <option value="6 months">6 months</option>
                            <option value="1 year">1 year</option>
                          </select>
                        </div>

                        <ReCAPTCHA
                          sitekey="6Lff5xMsAAAAAI23wsM17cv64hBjF2Q7ZSlCYBee"
                          onChange={(token) => setCaptchaToken(token)}
                          className="w-12/12"
                        />
                      </div>



                      <div className="flex justify-center items-center gap-4 xl:mt-6 mt-4">
                        <input className="mt-1" type="checkbox" id="" />
                        <label className="xl:text-sm text-sm " for="">
                          By clicking on Submit, I allow all communication from
                          Junior Toes International Preschool
                        </label>
                      </div>

                      <div className="flex justify-center xl:mt-6 mt-6 ">
                        <button
                          className=" text-white rounded xl:px-8 xl:py-2 px-8 py-2"
                          style={{ background: "#2d86a4" }}
                          type="submit"
                        >
                          Submit
                        </button>
                      </div>
                    </form>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* tab and mobile view */}
      <section
        className=" md:pt-32 pt-28 pb-12 md:pb-20 parkinsans bgh xl:hidden lg:hidden md:hidden sm:hidden hidden"
        style={{
          backgroundColor: "#f0f7fa",
          backgroundImage: `url(${bgg})`,
          backgroundPosition: "center center",
          backgroundRepeat: "repeat",
          backgroundSize: "55% auto",
        }}
      >
        <div className="px-4">
          <h2 class=" md:text-3xl text-2xl font-bold text-black ">
            Own a Preschool
          </h2>
          <p class="text-xl text-gray  mt-2" style={{ lineHeight: 1.9 }}>
            Become a part of the Junior Toes family and bring quality early
            childhood education to your community. With our proven curriculum,
            trusted brand, and comprehensive support, you can build a successful
            franchise that shapes the future of young learners. Fill out the
            form below to start your journey with Junior Toes Pre-School.
          </p>
          {/* <h1 className="text-2xl font-bold text-blue pt-4">
            Winner of 45+ Awards Across Categories
          </h1> */}

          <div className="flex  mt-6">
            <div className="md:block sm:hidden hidden">
              <div className="md:w-12/12 w-6/12">
                <img className="md:w-12/12  w-12/12" src={girlimg} alt="" />
              </div>
            </div>
            <div className=" bg-white border-blue rounded-xl shadow-xl md:p-12 p-6 z-10 md:-ml-4">
              {/* {formStatus === "success" && (
                <div className="text-center text-green-500 sofia-pro">
                  Thank you for submitting the form!
                </div>
              )} */}

              {/* Show Error Message */}
              {formStatus === "error" && (
                <div className="text-center text-red-500 sofia-pro">
                  There was an error submitting the form. Please try again.
                </div>
              )}
              <h1 className="md:text-3xl text-2xl text-black font-bold  text-center mb-8">
                Franchise Enquire Now
              </h1>

              <form ref={form} onSubmit={sendEmail}>
                <input
                  className=" w-12/12 rounded-lg borderform"
                  type="text"
                  id="text"
                  name="name"
                  placeholder="Name"
                  required
                />

                <input
                  className=" w-12/12 mt-4  rounded-lg borderform"
                  type="text"
                  id="text"
                  name="email"
                  placeholder="Email"
                  required
                />

                <input
                  className=" w-12/12 mt-4  rounded-lg borderform"
                  type="number"
                  id="number"
                  name="tel"
                  placeholder="Phone"
                  required
                />

                <input
                  className=" w-12/12 mt-4  rounded-lg borderform"
                  type="text"
                  id="text"
                  name="city"
                  placeholder="City"
                  required
                />

                <input
                  className=" w-12/12 mt-4  rounded-lg borderform"
                  type="text"
                  id="text"
                  name="area"
                  placeholder="Area Preferred"
                  required
                />

                <div className="">
                  <div className="">
                    <select
                      className=" w-12/12 mt-4 rounded-lg borderform"
                      id="academic"
                      name="investment"
                      placeholder=" Select Investment"
                      required
                    >
                      <option value="" disabled selected>
                        Select Investment
                      </option>

                      <option value="30-40 lakhs">30-40 lakhs</option>
                      <option value="40-50 lakhs">40-50 lakhs</option>
                      <option value="50-60 lakhs">50-60 lakhs</option>
                      <option value="Above 60lakhs">Above 60lakhs</option>
                    </select>
                  </div>

                  <div className="">
                    <select
                      className=" w-12/12 mt-4 mb-4 rounded-lg borderform "
                      id="academic"
                      name="franchise"
                      placeholder="How soon are you ready to start"
                      required
                    >
                      <option value="" disabled selected>
                        How soon are you ready to start
                      </option>

                      <option value="Immediately">Immediately</option>
                      <option value="6 months">6 months</option>
                      <option value="1 year">1 year</option>
                    </select>
                  </div>
                  <ReCAPTCHA
                    sitekey="6Lff5xMsAAAAAI23wsM17cv64hBjF2Q7ZSlCYBee"
                    onChange={(token) => setCaptchaToken(token)}
                    className="w-12/12"
                  />
                </div>

                <div className="flex justify-center items-center gap-4 xl:mt-6 mt-4">
                  <input className="mt-1" type="checkbox" id="" />
                  <label className="xl:text-sm text-sm " for="">
                    By clicking on Submit, I allow all communication from Junior
                    Toes International Preschool
                  </label>
                </div>

                <div className="flex justify-center xl:mt-6 mt-6 ">
                  <button
                    className=" text-white rounded xl:px-8 xl:py-2 px-8 py-2"
                    style={{ background: "#2d86a4" }}
                    type="submit"
                  >
                    Submit
                  </button>
                </div>
              </form>

            </div>
          </div>
        </div>
        <div className="xl:hidden lg:hidden md:block sm:block block">
          <div className="flex items-end">
            <img className="w-36 " src={bfly1} alt="" />
          </div>
        </div>
      </section>

      <section className=" xl:pt-16 xl:pb-16 lg:pt-16 lg:pb-0 md:pt-12 pt-12 pb-0 md:pb-16 bg-white">
        <div className="container mx-auto  ">
          <h1 className="xl:text-4xl lg:text-4xl md:text-3xl text-2xl text-black text-center  font-bold">
            Franchise Opportunity
          </h1>
          <div className="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-2 gap-6  xl:pt-6 xl:px-0 px-4">
            <div className=" xl:pt-12 lg:pt-12 md:pt-12 pt-12 xl:ml-12">
              <div className="flex gap-6">
                <div className="xl:w-2/12 lg:w-3/12 md:w-3/12 w-36">
                  <img
                    className="xl:w-9/12 lg:w-11/12 md:w-11/12 w-12/12"
                    src={visions}
                    alt="Franchise"
                  />
                </div>
                <div className="xl:w-8/12 lg:w-8/12 md:w-8/12 w-12/12">
                  <h1 className="xl:text-2xl text-2xl text-black font-semibold">
                    Long-term Vision
                  </h1>
                  <p className="xl:text-base text-base pt-2 xl:pt-2">
                    A business with sustained returns, provided one has a
                    long-term vision
                  </p>
                </div>
              </div>
              <div className="flex gap-6 xl:mt-8 lg:mt-8 md:mt-8 mt-6">
                <div className="xl:w-2/12 lg:w-3/12 md:w-3/12 w-36 ">
                  <img
                    className="xl:w-9/12 lg:w-11/12 md:w-11/12 w-12/12"
                    src={brand}
                    alt="Franchise"
                  />
                </div>
                <div className="xl:w-8/12 lg:w-8/12 md:w-8/12 w-12/12">
                  <h1 className="xl:text-2xl text-2xl text-black font-semibold">
                    Established Brand Name
                  </h1>
                  <p className="xl:text-base  text-base pt-2 xl:pt-2">
                    Associate with a legacy brand that has nurtured 5 lakh+
                    children
                  </p>
                </div>
              </div>
              <div className="flex gap-6 xl:mt-8 lg:mt-8 md:mt-8 mt-6">
                <div className="xl:w-2/12 lg:w-2/12 md:w-2/12 w-36">
                  <img
                    className="xl:w-9/12 lg:w-11/12 md:w-11/12 w-12/12"
                    src={map}
                    alt="Franchise"
                  />
                </div>
                <div className="xl:w-8/12 lg:w-8/12 md:w-8/12 w-12/12 xl:ml-0 lg:ml-6 md:ml-6">
                  <h1 className="xl:text-2xl text-2xl text-black font-semibold">
                    Proven Franchise Model
                  </h1>
                  <p className="xl:text-base xl:pt-2 pt-2">
                    Get 360-degree support at each step to hit the ground
                    running
                  </p>
                </div>
              </div>
            </div>
            <div className=" xl:mt-8 lg:mt-12 md:mt-12">
              <div>
                <img
                  className="xl:w-12/12 lg:w-12/12 md:w-12/12 xl:h-0 lg:h-0 md:h-420 object-fit rounded-lg "
                  src={franchisee}
                  alt="kids1"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      <section
        className=" parkinsans bg-gray xl:pb-16 xl:pt-16 lg:pt-16 lg:pb-16 md:pt-16 md:pb-16 pt-16 pb-16"
        style={{
          backgroundImage: `url(${bgg})`,
          backgroundPosition: "center center", // Correct property name
          backgroundRepeat: "repeat", // No need to quote unless special characters
          backgroundSize: "55% auto", // No dash in property names
        }}
      >
        <div className="container mx-auto ">
          <div className="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-8 lg:grid-cols-8 xl:grid-cols-8    gap-6 xl:px-0 px-4">
            <div
              className="xl:col-span-5 lg:col-span-5 md:col-span-5 col-span-1

 "
            >
              <p className="xl:text-lg text-lg text-peach font-bold bubblegum uppercase">
                Why Choose us
              </p>
              <h1 className="xl:text-4xl lg:text-3xl text-2xl pt-4 text-black xl:pt-4 font-bold">
                We believe that every child<br></br> deserves the best start in
                life
              </h1>
              <p
                class="xl:text-xl text-gray  xl:mt-3 xl:mr-24 mt-2"
                style={{ lineHeight: 1.9 }}
              >
                Become a part of the Junior Toes family and bring quality early
                childhood education to your community. With our proven
                curriculum, trusted brand, and comprehensive support, you can
                build a successful franchise.
              </p>
              <div className=" xl:mt-4 mt-4">
                <a href="/ourstory">
                  <button
                    className=" text-white rounded xl:px-8 xl:py-2 px-8 py-2"
                    style={{ background: "#2d86a4" }}
                    type="submit"
                  >
                    Know More
                  </button>
                </a>
              </div>
            </div>

            <div className="xl:col-span-3 lg:col-span-3 md:col-span-3 col-span-1 xl:mt-0 lg:mt-0 md:mt-0 mt-6 border-peach">
              <div className="">
                <div className=" xl:pt-28 lg:pt-20 md:pt-28 pt-12 pb-16 xl:pb-0 lg:pb-0 md:pb-0">
                  <div className="">
                    <h1 className="xl:text-7xl lg:text-6xl md:text-5xl text-5xl text-black font-semibold center-button">
                      10+
                    </h1>
                    <p className="xl:text-xl text-sm pt-2 text-black xl:pt-2 text-center">
                      Locations
                    </p>
                  </div>
                </div>
              </div>
              <div className="grid grid-cols-2 gap-4">
                <div className="">


                  {/* <div className="background-blue xl:py-12 xl:w-12/12 lg:py-12 lg:w-12/12 md:py-8 md:w-12/12 mt-4  flex justify-center items-center xl:mt-4 py-8 w-12/12">
                    <div className="">
                      <h1 className="xl:text-6xl lg:text-6xl md:text-3xl text-2xl text-white font-semibold center-button">
                        21+
                      </h1>
                      <p className="xl:text-sm text-sm pt-2 text-white xl:pt-2">
                        years of expertise
                      </p>
                    </div>
                  </div> */}
                </div>

                {/* <div className="">
                  <div className="background-blue xl:py-12 xl:w-12/12 lg:py-12 lg:w-12/12 md:py-8 md:w-12/12  flex justify-center items-center py-8 w-12/12 ">
                    <div className="">
                      <h1 className="xl:text-6xl lg:text-6xl md:text-3xl text-2xl text-white font-semibold center-button">
                        9+
                      </h1>
                      <p className="xl:text-sm text-sm pt-2 text-white xl:pt-2">
                        locations
                      </p>
                    </div>
                  </div>

                  <div className="border-peach xl:py-10 xl:w-12/12 lg:py-10 lg:w-12/12 md:py-8 md:w-12/12 mt-4  flex justify-center items-center xl:mt-4 py-10 w-12/12">
                    <div className="">
                      <h1 className="xl:text-6xl lg:text-6xl md:text-3xl text-black font-semibold center-button">
                        5+
                      </h1>
                      <p className="xl:text-sm text-sm pt-2 text-black xl:pt-2 text-center">
                        Kindergarten
                      </p>
                    </div>
                  </div>
                </div> */}




              </div>
            </div>
          </div>
        </div>
      </section>

      <section
        className="bgh parkinsans "
      // style={{
      //   backgroundImage: `url(${backgroundimg})`,
      //   width: "100%",
      // }}
      >
        <section className="container mx-auto xl:pt-16  xl:pb-16 lg:pt-16 lg:pb-20 md:pt-16 md:pb-16  parkinsans rounded-md pt-12 pb-12">
          <h2 class="xl:text-5xl lg:text-4xl md:text-3xl text-2xl font-bold text-black text-center ">
            Our Diverse Offerings
          </h2>
          <p
            className="xl:text-xl lg:text-xl md:text-base text-base xl:pt-3 text-black text-center xl:w-9/12 lg:w-9/12 md:w-10/12 justify-center mx-auto"
            style={{ lineHeight: 1.9 }}
          >
            Welcome to Junior Toes, where little feet take big steps! Our
            preschool is designed to nurture curiosity, creativity, and growth,
            one step at a time. Join us in our playful learning journey.
          </p>
          <div className="flex justify-center items-center ">
            <div className="xl:ml-0 lg:ml-0 md:ml-0 -ml-4">
              <div className="center-button xl:mt-16 lg:mt-16 md:mt-16 mt-8 ">
                <div className="flex justify-center items-center floatingg ">
                  <img
                    className="xl:w-20 lg:w-20 md:w-20 w-16"
                    src={infrastructure}
                    alt=""
                  />
                </div>
              </div>
              <h1 className="text-black text-center  pt-3 xl:text-lg lg:text-lg md:text-lg text-base">
                Infrastructure &<br></br> Ambience Design
              </h1>
            </div>

            <div className="xl:ml-52 lg:ml-32 md:ml-32 ml-16">
              <div className="center-button xl:mt-16 lg:mt-16 md:mt-16 mt-8">
                <div className=" flex justify-center items-center floatingg ">
                  <img
                    className="xl:w-20 lg:w-20 md:w-20 w-16"
                    src={curriculums}
                    alt=""
                  />
                </div>
              </div>
              <h1 className="text-black text-center  pt-3 xl:text-lg lg:text-lg md:text-lg text-base">
                Researched <br></br>Curriculum
              </h1>
            </div>
          </div>
          <div className="grid grid-cols-3 xl:px-12 xl:pt-8 mt-6">
            <div>
              <div className="xl:ml-16">
                <div className="center-button">
                  <div className="flex justify-center items-center floatingg ">
                    <img
                      className="xl:w-20 lg:w-20 md:w-20 w-16"
                      src={teacher}
                      alt=""
                    />
                  </div>
                </div>
                <h1 className="text-black text-center  pt-3 xl:text-lg lg:text-lg md:text-lg text-base">
                  Teacher Training &<br></br> Skill Updating
                </h1>
              </div>

              <div className="xl:-ml-32">
                <div className="center-button xl:mt-14 lg:mt-8 md:mt-8 mt-6">
                  <div className=" flex justify-center items-center floatingg ">
                    <img
                      className="xl:w-20 lg:w-20 md:w-20 w-16"
                      src={yoga}
                      alt=""
                    />
                  </div>
                </div>
                <h1 className="text-black text-center  pt-3 xl:text-lg lg:text-lg md:text-lg text-base">
                  Yoga and<br></br> Meditation
                </h1>
              </div>
            </div>

            <div>
              <div className="absolute justify-center mx-auto xl:block lg:block md:hidden sm:hidden hidden">
                <img
                  className="xl:w-4/12 lg:w-5/12 justify-center xl:ml-16 lg:ml-12 xl:-mt-10 lg:-mt-8 lg:-mt-12"
                  src={girl}
                  alt=""
                />
              </div>

              <div className="absolute justify-center mx-auto xl:hidden lg:hidden md:block sm:block block">
                <img
                  className="md:w-6/12 md:ml-6 w-12/12 justify-center -ml-12 -mt-8"
                  src={girl}
                  alt=""
                />
              </div>
            </div>

            <div>
              <div className="">
                <div className="center-button">
                  <div className="flex justify-center items-center floatingg xl:mt-0 lg:mt-0 md:mt-0 mt-4 ">
                    <img
                      className="xl:w-20 lg:w-20 md:w-20 w-16"
                      src={furniture}
                      alt=""
                    />
                  </div>
                </div>
                <h1 className="text-black text-center  pt-3 xl:text-lg lg:text-lg md:text-lg text-base">
                  Furniture &<br></br> Equipment
                </h1>
              </div>

              <div className="xl:ml-42">
                <div className="center-button xl:mt-14 lg:mt-8 md:mt-8 mt-6">
                  <div className=" flex justify-center items-center floatingg ">
                    <img
                      className="xl:w-20 lg:w-20 md:w-20 w-16"
                      src={sports}
                      alt=""
                    />
                  </div>
                </div>
                <h1 className="text-black text-center  pt-3 xl:text-lg lg:text-lg md:text-lg text-base">
                  Sports and<br></br> Games
                </h1>
              </div>
            </div>
          </div>
        </section>
      </section>

      <Footer2 />
    </>
  );
}
